import { gql } from '@apollo/client/core';

export const hasActiveConsent = gql`
  query HasActiveConsent($orgId: String!) {
    hasActiveConsent(orgId: $orgId)
  }
`;

export const giveConsent = gql`
  mutation GiveConsent($orgId: String) {
    giveConsent(orgId: $orgId) {
      id
      policyVersion
      basis
      retentionExpiry
      isActive
      createdAt
      organization {
        id
        name
        avatar
      }
    }
  }
`;

export const organizationActiveConsents = gql`
  query OrganizationActiveConsents($orgId: String) {
    organizationActiveConsents(orgId: $orgId) {
      id
      policyVersion
      basis
      retentionExpiry
      isActive
      createdAt
      user {
        id
        firstname
        lastname
        avatar
      }
    }
  }
`;
